// components/loadingControl.js
let setLoadingFn = null;

export const setLoadingSetter = (setter) => {
  setLoadingFn = setter;
};

export const loadingControl = (state) => {
  if (setLoadingFn) setLoadingFn(state);
};
